import React, {useRef, useState, Fragment, ComponentProps} from 'react';
import b_ from 'b_';

import {Button, Popup, Icon} from 'client/common/components/lego';

import I18N from 'assets/i18n/brandlift-project';

import './mode-button.css';

const i18n = I18N.common.modeButton;
const b = b_.with('mode-button');

function ModePopupContent() {
    return (
        <div className={b('content')}>
            <div>{i18n.popupContent}</div>
        </div>
    );
}

type ButtonProps = ComponentProps<typeof Button>;

export default function ModeButton(props: ButtonProps) {
    const buttonRef = useRef(null);
    const [displayPopup, setDisplayPopup] = useState(false);

    const {className = '', width} = props;

    return (
        <Fragment>
            <Button
                className={`${b('help-btn')} ${className}`}
                view='dl-default'
                size='s'
                onClick={() => setDisplayPopup(prev => !prev)}
                width={width}
                iconRight={(cls: string) => {
                    return <Icon className={cls} type='help' />;
                }}
                innerRef={buttonRef}
            >
                {i18n.label}
            </Button>
            <Popup
                anchor={buttonRef}
                onClose={() => setDisplayPopup(false)}
                className={b('info-popup')}
                direction='bottom-end'
                target='anchor'
                view='default'
                visible={displayPopup}
                zIndex={2000}
            >
                <ModePopupContent />
            </Popup>
        </Fragment>
    );
}
